import React, { useState, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoutUser from "../../api/logout";
import { AuthContext } from "../../context/Auth/AuthContext";
import { DigitalSignatureContext } from "../../context/DigitalSignature/DigitalSignatureContext";
import "../../styles/Dropdown.css";

// nablasol@consumerlaw.com
// Clg@123!*

const Dropdown = () => {
  const [itemClicked, setItemClicked] = useState(false);
  const { instance } = useMsal();

  const { token, dispatch } = useContext(AuthContext);
  const { dispatch: signDispatch } = useContext(DigitalSignatureContext);

  const redirect = useNavigate();

  const logoutFn = async () => {
    const data = await logoutUser({ token });
  };

  const handleLogout = async () => {
    instance
      .logoutPopup()
      .then(() => {
        logoutFn();
        setItemClicked(!itemClicked);
        dispatch({ type: "LOGOUT" });
        signDispatch({ type: "DELETEDIGITALSIGN" });
        redirect("/login");
        toast.success("Successfully Logged Out", {
          position: "top-center",
          autoClose: 3000,
          theme: "dark",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return (
    <div className={!itemClicked ? "dropdown-content" : "clicked"}>
      <ul className="navbar-dropdown">
        <li>
          <div onClick={handleLogout} className="dropdown-links">
            Logout
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Dropdown;
